module.exports = __webpack_public_path__ + "static/dryad-b2f8e3d6f577177c08ca31518856ccb7.jpg";